import { Burger } from '../core'

export default {
  burger: undefined,

  init() {
    /* Burger */
    let obj = this
    obj.burger = new Burger('.burger', {
      onToggle: function() {
        var scrollTop = window.scrollY;
        obj.top = scrollTop
        $('body').css('--top',-scrollTop + 'px');
        if (obj.burger.isExpanded) {
          $('body').addClass('--menu-open --no-scroll')
        } else {
          $('body').removeClass('--menu-open --no-scroll')
        }
      },
    })

    $('.js-close-menu').click(function() {
      $('body').removeClass('--menu-open --no-scroll')
      $('.header__burger').attr('aria-expanded', 'false');
      window.scrollTo({ top: obj.top});
      $('main .page-section').first().click();
    });

    $(window).click(function() {
      if ($('body').hasClass('--menu-open')) {
        $('body').removeClass('--menu-open --no-scroll')
        $('.header__burger').attr('aria-expanded', 'false');
        window.scrollTo({ top: obj.top});
        $('main .page-section').first().click();
      }
    });

    $('.navigation__wrapper, .header__burger, .header__search, .header__search-btn').click(function(event){
      event.stopPropagation();
    });

    function scrollHeader() {
      if (!$('body').hasClass('--menu-open')) {
        if (window.scrollY <= 40) {
          $('.header').css('top', '-'+window.scrollY+'px')
          $('.header').removeClass('--shrinked')
        } else {
          $('.header').css('top', '-40px')
          $('.header').addClass('--shrinked')
        }
        if (window.scrollY < 10) {
          $('.header').removeClass('--shrink-logo')
        } else {
          $('.header').addClass('--shrink-logo')
        }
      }
    }

    $(window).scroll(function() {
      scrollHeader()
    });

    $(window).on('load resize orientationchange', scrollHeader())
  }
}
